document.addEventListener("DOMContentLoaded", function() {

    // swiper výpis nemovitostí
    //=========================
    (function () {
        let switchSelector = document.querySelector('[data-switch-list]');
        if(typeof(switchSelector) === 'undefined' || switchSelector === null)
            return;

        let switchButtons = switchSelector.querySelectorAll('.ButtonBase'),
            list = document.querySelector('.js-estateList'),
            items = document.querySelectorAll('[data-estate-list-item]');

        switchButtons.forEach((button) => {
            button.addEventListener('click', () => {
                hide();
                list.setAttribute('data-layout', button.dataset.listLayout);
                items.forEach((item) => {
                    item.setAttribute('data-layout', button.dataset.listLayout);
                });
                button.classList.add('is-active');
            });
        });

        function hide() {
            switchButtons.forEach((button) => {
                button.classList.remove('is-active');
            });
        }

    }());
});